module.exports = __webpack_public_path__ + "media/images/employees/laci-dda31249c9e7d320b6c7062bedb26f51.png";